module.exports = __webpack_public_path__ + "img/new_banner_workts.cb51326c.png";